import { IRegEdReviewNotice } from '@Queries/RegEdCompliance';
import moment from 'moment';

const formatDays = (days: number) => `${days} day${days === 1 ? '' : 's'}`;
// "1 day's notice" but "3 days' notice".
const formatNotice = (days: number) => `${days} ${days === 1 ? "day's" : "days'"} notice`;

/**
 * The scheduler's wait when RegEd questions were left to the account's user. The broker-dealer's window is
 * counted from when they answer, which is after this, so the floor can't promise to avoid a short-notice reason.
 */
export const getRegEdReviewNoticeWarning = (
	notice: IRegEdReviewNotice,
	{
		noun,
		action,
		sendOnBehalfUntil,
		sendOnBehalfWait,
	}: { noun: string; action: string; sendOnBehalfUntil?: moment.MomentInput; sendOnBehalfWait?: string }
) => {
	const noticeWindow = formatDays(notice.days);
	const firm = notice.brokerDealerName || 'The broker-dealer';
	const shortNotice = `if the account's user answers within ${noticeWindow} of ${action}, they'll need to explain the short notice.`;
	// The floor is the later of the two waits; when send-on-behalf is the longer one, the firm's window isn't why.
	const sendOnBehalfIsLonger =
		!!sendOnBehalfUntil && !!sendOnBehalfWait && moment(sendOnBehalfUntil).isAfter(moment().add(notice.days, 'days'));
	return sendOnBehalfIsLonger
		? `Since you're ${action} this on behalf of another user, schedule it at least ${sendOnBehalfWait} ahead. ${firm} needs ${formatNotice(notice.days)} to review it; ${shortNotice}`
		: `${firm} needs ${formatNotice(notice.days)} to review this ${noun}, so schedule it at least ${noticeWindow} ahead. ${shortNotice.charAt(0).toUpperCase()}${shortNotice.slice(1)}`;
};
